
import { TranslationsByLanguage } from './types';

export type DashboardTranslationKey =
  | 'dashboard.title'
  | 'dashboard.welcome'
  | 'dashboard.downloads'
  | 'dashboard.creations'
  | 'dashboard.profile'
  | 'dashboard.recentDownloads'
  | 'dashboard.recentDownloadsDesc'
  | 'dashboard.noDownloads'
  | 'dashboard.creationsDesc'
  | 'dashboard.noCreations'
  | 'dashboard.profileDesc'
  | 'dashboard.name'
  | 'dashboard.email'
  | 'dashboard.role';

export const dashboardTranslations: TranslationsByLanguage = {
  en: {
    'dashboard.title': 'Creator Dashboard',
    'dashboard.welcome': 'Welcome',
    'dashboard.downloads': 'My Downloads',
    'dashboard.creations': 'My Creations',
    'dashboard.profile': 'My Profile',
    'dashboard.recentDownloads': 'Recent Downloads',
    'dashboard.recentDownloadsDesc': 'Your recently downloaded clips',
    'dashboard.noDownloads': 'You haven\'t downloaded any clips yet',
    'dashboard.creationsDesc': 'Your submitted derivative works',
    'dashboard.noCreations': 'You haven\'t created any derivative works yet',
    'dashboard.profileDesc': 'Your account information',
    'dashboard.name': 'Name',
    'dashboard.email': 'Email',
    'dashboard.role': 'Role',
  },
  fr: {
    'dashboard.title': 'Dashboard Créateur',
    'dashboard.welcome': 'Bienvenue',
    'dashboard.downloads': 'Mes Téléchargements',
    'dashboard.creations': 'Mes Créations',
    'dashboard.profile': 'Mon Profil',
    'dashboard.recentDownloads': 'Téléchargements Récents',
    'dashboard.recentDownloadsDesc': 'Vos clips récemment téléchargés',
    'dashboard.noDownloads': 'Vous n\'avez pas encore téléchargé de clips',
    'dashboard.creationsDesc': 'Vos œuvres dérivées soumises',
    'dashboard.noCreations': 'Vous n\'avez pas encore créé d\'œuvres dérivées',
    'dashboard.profileDesc': 'Vos informations de compte',
    'dashboard.name': 'Nom',
    'dashboard.email': 'Email',
    'dashboard.role': 'Rôle',
  }
};
